import { firebaseSdk } from './firebaseSdk'

export const clientServerTimestamp =
  firebaseSdk.firestore.FieldValue.serverTimestamp
